var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditavt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1434_11198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9994 2.52639C13.9178 2.83552 13.7069 3.05271 13.4877 3.26825C13.0911 3.6586 12.7015 4.0561 12.3208 4.43873C11.3697 3.48269 10.4249 2.53299 9.47266 1.57613C9.4817 1.56622 9.5069 1.53484 9.53511 1.50649C9.89561 1.14367 10.2558 0.780583 10.6174 0.41887C11.1741 -0.138014 11.929 -0.139941 12.4862 0.415016C12.8325 0.759662 13.1719 1.11147 13.522 1.45226C13.7334 1.65844 13.926 1.87205 13.9992 2.16908C13.9994 2.28827 13.9994 2.40747 13.9994 2.52639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3421 12.4197C3.40716 11.4818 2.46345 10.5354 1.53125 9.60033C3.92572 7.1958 6.32703 4.78465 8.7152 2.38672C9.63973 3.31578 10.5851 4.26603 11.5206 5.2061C9.13185 7.60623 6.73382 10.0163 4.3421 12.4197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.721 10.4023C1.65758 11.3429 2.59554 12.2849 3.53842 13.2316C3.33461 13.282 3.113 13.3373 2.89084 13.3912C2.0704 13.5905 1.25024 13.7901 0.42926 13.9878C0.164638 14.0513 -0.0476612 13.8614 0.00931727 13.5993C0.241066 12.5346 0.480486 11.4715 0.717439 10.4075C0.719083 10.4001 0.727027 10.3943 0.721 10.4023Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1434_11198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditavt);
export default __webpack_public_path__ + "static/media/editavt.c0c89c4cd8d0eea2b3a69892afa28a23.svg";
export { ForwardRef as ReactComponent };